<template>
  <div class="Projects">
    <div :class="isMobile == 0 ? '' : 'Projects_box_mobile'" class="Projects_box">
      <!-- 大标题：添加动画类 -->
      <div :class="isMobile == 0 ? '' : 'Projects_big_title_mobile'" class="Projects_big_title animate-fade-in"
        v-if="lang.fyType == 2">PROJECTS</div>
      <div :class="isMobile == 0 ? '' : 'Projects_big_title_mobile'" class="Projects_big_title animate-fade-in" v-else>
        项目
      </div>

      <!-- 项目列表：添加动画类，按索引设置延迟 -->
      <router-link v-for="(item, index) in projects" :key="index" :to="`/Project-detail/${item.id}`"
        :class="isMobile == 0 ? '' : 'Projects_small_box_mobile'" class="Projects_small_box animate-fade-in"
        :style="{ animationDelay: `${0.3 + index * 0.2}s` }">
        <div :class="isMobile == 0 ? '' : 'Projects_small_title_mobile'" class="Projects_small_title"
          v-html="item.translations.title.content"></div>
        <div v-if="isMobile == 0" class="Projects_small_title" v-html="item.translations.subtitle.content"></div>
        <div  :class="isMobile == 0 ? '' : 'News_button_mobile'"class="News_button" style="margin-top: 20px;">
          <div class="News_button_text" v-if="lang.fyType == 2">Learn more</div>
          <div class="News_button_text" v-else>了解更多</div>
          <img class="News_button_icon" src="../assets/bluenext.png" alt="箭头图标" />
        </div>
        <img :class="isMobile == 0 ? '' : 'projects_img_mobile'" class="projects_img"
          :src="'https://app.choisiyachts.com' + getImgeList(item.main_image)"></img>
      </router-link>
    </div>
    <bottom-text></bottom-text>
  </div>
</template>

<script>
// 脚本部分保持不变
import { proList, newsList } from '../../request/api.js'
import router from '@/router';
import bottomText from './bottomText.vue';
export default {
  components: {
    bottomText
  },
  name: 'Projects',
  data() {
    return {
      lang: {},
      projects: [],
      isMobile: 0
    }
  },
  watch: {
    lang: {
      handler(newLang, oldLang) {
        console.log('Lang 变化了：', newLang);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.isMobile = localStorage.getItem('isMobile')
    this.lang = JSON.parse(localStorage.getItem('Lang'))
    if (this.lang.fyType == 2) {
      this.getNewsList('en')
    } else {
      this.getNewsList('zh')
    }
    window.addEventListener('langChange', () => {
      this.syncLangFromStorage();
    });
  },
  created() {
  },
  methods: {
    getImgeList(string) {
      return string.split(',')[0]
    },
    syncLangFromStorage() {
      this.lang = JSON.parse(localStorage.getItem('Lang'))
      console.log(this.lang)
      if (this.lang.fyType == 2) {
        this.getNewsList('en')
      } else {
        this.getNewsList('zh')
      }
    },
    getNewsList(language) {
      let data = {
        page: 1,
        limit: 999,
        category: '项目',
        language
      }
      newsList(data).then(res => {
        this.projects = res.data.data
      })
    }
  }
}
</script>

<style>
/* 原有样式保持不变 */
.Projects {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.Projects_box {
  display: flex;
  flex-direction: column;
  width: 71%;
  margin: 60px auto;
}

.Projects_box_mobile {
  width: 92%;
  margin-top: 15px;
}

.Projects_big_title {
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 36px;
  color: #021131;
  line-height: 36px;
  text-align: left;
  margin-bottom: 40px;
}

.Projects_big_title_mobile {
  margin-bottom: 20px;
  font-size: 28px;
}

.Projects_small_box {
  padding-top: 105px;
  position: relative;
  width: 100%;
  height: 356px;
  border-radius: 0px 0px 0px 0px;
  padding-bottom: 60px;
  margin-bottom: 40px;
  border-bottom: 1px solid #6488C6;
}

.Projects_small_box_mobile {
  padding-top: 0px;
  height: 150px;
  padding-bottom: 24px;
}

.Projects_small_box {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.Projects_small_box:hover {
  transform: translateY(-5px);
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.Projects_small_title {
  width: 52%;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 28px;
  color: #021131;
  line-height: 39px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.Projects_small_title_mobile {
  width: 50%;
  line-height: 25px;
  font-size: 20px;
  display: -webkit-box;
  /* 必須設置為彈性盒子 */
  -webkit-box-orient: vertical;
  /* 垂直排列子元素 */
  -webkit-line-clamp: 3;
  /* 限制顯示 3 行 */
  overflow: hidden;
  /* 隱藏超出內容 */
  text-overflow: ellipsis;
  /* 顯示省略號 */
}

.learn_more {
  margin-top: 20px;
  width: 176px;
  height: 48px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #6488C6;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #6488C6;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 48px;
  text-align: center;
}

.projects_img {
  position: absolute;
  top: 0;
  right: 0;
  width: 640px;
  height: 356px;
}

.projects_img_mobile {
  width: 180px;
  height: 150px;
}

.News_button {
  display: flex;
  align-items: center;
  width: 176px;
  height: 48px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #6488C6;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #6488C6;
  background: white;
  transition: color 0.5s ease;
  position: relative;
  overflow: hidden;
}
.News_button_mobile{
  padding: 10px;
  width: 150px;
  height: 30px;
}
.News_button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: #6488C6;
  transition: width 0.5s ease;
  z-index: 0;
}

.Projects_small_box:hover .News_button {
  color: white;
}

.Projects_small_box:hover .News_button::before {
  width: 100%;
}

.News_button_text {
  z-index: 1;
}

.News_button_icon {
  width: 8px;
  height: 14px;
  margin-left: 10px;
  margin-top: 2px;
  z-index: 1;
}

/* 添加浮现动画样式 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;
}

/* 设置延迟顺序 */
.Projects_big_title {
  animation-delay: 0s;
  /* 标题最先显示 */
}
</style>